import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Country from "../../../domains/Country";

interface CountriesState {
  countries: Array<Country>
  areCountriesLoading: boolean
  hasErrorLoadingCountries: boolean
}

const initialState: CountriesState = {
  countries: [],
  areCountriesLoading: false,
  hasErrorLoadingCountries: false,
};

export const SLICE_NAME = "countries";

export const countriesSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getCountries: (
      state,
      action: PayloadAction<{ areCountriesLoading: boolean }>,
    ) => {
      state.areCountriesLoading = action.payload.areCountriesLoading;
    },
    getCountriesSuccess: (
      state,
      action: PayloadAction<{
        countries: Array<Country>
        areCountriesLoading: boolean
      }>,
    ) => {
      state.countries = [...action.payload.countries];
      state.areCountriesLoading = action.payload.areCountriesLoading;
    },
    getCountriesError: (state, action: PayloadAction<{hasErrorLoadingCountries: boolean, areCountriesLoading: boolean}>) => {
      state.areCountriesLoading = action.payload.areCountriesLoading;
      state.hasErrorLoadingCountries = action.payload.hasErrorLoadingCountries;
    }
  },
});


export const { getCountries, getCountriesError, getCountriesSuccess } = countriesSlice.actions;

export default countriesSlice.reducer;